const path = '$presence';

export const EVENT_PRESENCE_INTERVAL = `${path}/presence/interval`